import { render, staticRenderFns } from "./Kana.vue?vue&type=template&id=10c5d2c4"
import script from "./Kana.vue?vue&type=script&lang=js"
export * from "./Kana.vue?vue&type=script&lang=js"
import style0 from "./Kana.vue?vue&type=style&index=0&id=10c5d2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports